export const envVars = {
	base: {
		publicUrl: '%%%REACT_APP_PUBLIC_URL%%%',
		environmentReturnUrl: '%%%REACT_APP_ENVIRONMENT_RETURN_URL%%%',
	},
	api: {
		headers: {},
		url: '%%%REACT_APP_API_URL%%%',
		certificateUrl: '%%%REACT_APP_API_CERTIFICATE_URL%%%',
	},
	logger: {
		debug: '%%%REACT_APP_LOGGER_DEBUG%%%',
		error: '%%%REACT_APP_LOGGER_ERROR%%%',
		log: '%%%REACT_APP_LOGGER_LOG%%%',
		buildNumber: '%%%REACT_APP_BUILD_NUMBER%%%',
	},
	cookies: {
		domain: '%%%REACT_APP_COOKIES_DOMAIN%%%',
	},
	maxElapsedEpochMs: '%%%REACT_APP_MAX_ELAPSED_EPOCH_MS%%%',
};
